module.exports = __webpack_public_path__ + "static/media/client-panel.8507acf8.gif";